import img1 from "./WhatsApp Image 2025-11-25 at 3.40.30 PM.jpeg";
import img2 from "./WhatsApp Image 2025-11-25 at 3.40.31 PM (1).jpeg";
import img3 from "./WhatsApp Image 2025-11-25 at 3.40.31 PM (2).jpeg";
import img4 from "./WhatsApp Image 2025-11-25 at 3.40.31 PM.jpeg";
import img5 from "./WhatsApp Image 2025-11-25 at 3.40.32 PM (1).jpeg";
import img6 from "./WhatsApp Image 2025-11-25 at 3.40.32 PM (2).jpeg";
import img7 from "./WhatsApp Image 2025-11-25 at 3.40.32 PM.jpeg";

export default [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
];
